<h2 mat-dialog-title class="view-dialog-title">
  <mat-icon>description</mat-icon>
  <span>{{ data.template.name }}</span>
</h2>

<mat-dialog-content class="view-dialog-content">
  @if (isLoading) {
    <div class="preview-loading">
      <app-rings-loader></app-rings-loader>
    </div>
  }
  @if (!isLoading) {
    <div class="template-preview" [innerHTML]="previewHtml | safeHtml"></div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'Close' | translate }}</button>
</mat-dialog-actions>
